import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import OfferTypeModel from 'models/OfferType';
import ProjectModel from 'models/Project';
import PageTransition from 'containers/PageTransition';
import Head from 'components/Head';
import SlidingPageTransition from 'components/SlidingPageTransition';
import TagsSection from 'components/TagsSection';
import HeadingSection from 'components/HeadingSection';
import MarkdownSection from 'components/MarkdownSection';
import GallerySection from 'components/GallerySection';
import QuoteSection from 'components/QuoteSection';
import BannerSection from 'components/BannerSection';

import Link from 'next/link';
import Wrapper from './styled/Wrapper';
import ContentWrapper from './styled/ContentWrapper';
import InnerContentWrapper from './styled/InnerContentWrapper';
import Background from './styled/Background';
import BurgerButton from './styled/BurgerButton';
import BurgerMenu from './styled/BurgerMenu';
import SecondaryFooter from './styled/SecondaryFooter';
import CaseStudyWrapper from './styled/CaseStudyWrapper';
import HomeButton from './styled/HomeButton';
import CaseStudyReference from './styled/CaseStudyReference';

export default class OfferCaseStudyPage extends PureComponent {


  static contextType = ThemeContext;

  static getSectionComponent(section, key) {
    const SectionComponent = OfferCaseStudyPage.sectionsMapping[section.__typename];

    if (SectionComponent) {
      return React.createElement(SectionComponent, {
        key: `${key}-${section.__typename}`,
        ...section,
      });
    }

    console.warn(`No section found for section ${section.__typename}`);
    return null;
  }

  static sectionsMapping = {
    'ComponentContentsHeadingSection': HeadingSection,
    'ComponentContentsContent': MarkdownSection,
    'ComponentContentsGallerySection': GallerySection,
    'ComponentContentsQuoteSection': QuoteSection,
    'ComponentContentsMarkdownSection': BannerSection,
  };

  state = {
    isMenuVisible: false,
  };

  componentDidMount() {
    // const { router } = this.props;
    // if(appState.analytics)appState.analytics._trackPageView(router.pathname.replace('[slug]', router.query.slug));
  }

  onBurgerClick = () => {
    const { isMenuVisible } = this.state;
    this.setState({ isMenuVisible: !isMenuVisible });
    // if(appState.analytics)appState.analytics._trackEvent('OfferCaseStudyPage', 'click burger');
  };

  onTopClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // if(appState.analytics)appState.analytics._trackEvent('OfferCaseStudyPage', 'click top');
  };

  render() {
    const {
      router,
      offer,
      offerTypes,
      caseStudy,
      navItems,
      footerLinkPrev,
      footerLinkNext,
    } = this.props;

    const { isMenuVisible } = this.state;
    const { ogTags } = offer;
    const otherOfferTypes = offerTypes.filter(type => type.id !== offer.id);

    return (
      <>
        <Head ogTags={ogTags} router={router} />
        {/* <PageTransition router={router} component={SlidingPageTransition}> */}
          <Wrapper theme={this.context} dark={isMenuVisible}>
            <ContentWrapper hidden={isMenuVisible}>
              <Background blank />
              <InnerContentWrapper>
                <TagsSection {...offer} links={otherOfferTypes} baseUrl="/capabilities" />
                <CaseStudyWrapper>
                  {offer.caseStudy.contents.map((section, index) =>
                    OfferCaseStudyPage.getSectionComponent(section, index),
                  )}
                  {caseStudy && <CaseStudyReference project={caseStudy} baseLink={'/projects'} />}
                </CaseStudyWrapper>
              </InnerContentWrapper>
              <SecondaryFooter
                prevLink={footerLinkPrev}
                nextLink={footerLinkNext}
                onTopButtonClick={this.onTopClick}
              />
            </ContentWrapper>
            <BurgerMenu router={router} items={navItems} light={false} hidden={!isMenuVisible} />
            <BurgerButton isActive={isMenuVisible} light={!isMenuVisible} onClick={this.onBurgerClick} />
            <Link href="/" passHref>
              <HomeButton />
            </Link>
          </Wrapper>
        {/* </PageTransition> */}
      </>
    );
  }
}
